import {IRegexHelper} from "./regexTypes";

//TODO localization
export const EmailRegex: IRegexHelper = {
  pattern: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/gm,
  error: "Incorrect email",
}